import React, { useEffect, useState, useRef } from "react";
import "./add-user-info.scss";
import AdminNavigation from "@components/Admin/admin-navigation";
import {
  adminCreateUser,
  adminGetSpecificUser,
  adminUpdateSpecificUser,
} from "@services/users.service";
import { toast } from "react-toastify";
import InputField from "@_common/InputRuleFeild";
import { getValue, setValue } from "@utils/lodash";
import { adminGetAllRoles, adminGetRoles } from "@services/roles.service";
import SimpleReactValidator from "simple-react-validator";
import { useParams, useNavigate } from "react-router-dom";
import countries from "@_common/contry.json";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import _ from "lodash";
import PromptModal from "../../../../prompt/modal";
import { useCallbackPrompt } from "../../../../prompt/useCallbackPrompt";
import NoAccessPage from "@components/common/NoAccess";
import Loader from "@components/common/Loader";
import Switch from "@components/list-management/switch";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { sanitizeInput } from "@_common/dompurify";

interface IUserDetailsInfoProps {}

const UserDetailsInfo: React.FunctionComponent<IUserDetailsInfoProps> = (
  props: any,
) => {
  let orgParams = useParams();
  let params = useParams();
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const intialState = {
    first_name: "",
    last_name: "",
    email: "",
    mobile_area_code: "",
    mobile_number: "",
    roles: [],
    user_timezone: "Asia/Kolkata",
    is_super_user: false,
    user_type: "CLIENT",
    is_invite: false,
    is_mfa: false,
    // send_invite: false,
  };
  const [request, setRequest] = useState(intialState);

  const [dirtyFields, setDirtyFields] = useState<any>(intialState);

  const reset = () => {
    setRequest(intialState);
    setDirtyFields(intialState);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rolesList, setRolesList] = useState([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    if (props.permissionAPITriggered) {
      if (getValue(params, `id`, "") && props.permissionAPITriggered) {
        getSpecificUser(getValue(params, `id`, ""));
      } else {
        setLoading(false);
      }
      getRolesList();
    }
  }, [props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getSpecificUser = async (id: string) => {
    try {
      setLoading(true);
      let resp = await adminGetSpecificUser(id);
      if (resp) {
        let countryCode = countries.filter(
          (item: object) =>
            getValue(item, `dial_code`, "") ===
            getValue(resp, `data.mobile_area_code`, ""),
        );
        // mobile_area_code
        let code: any =
          countryCode.length > 0 &&
          countryCode.map((item) => ({
            id: getValue(item, `id`, ""),
            country: item.code,
            label: <>{item.dial_code + " " + item.name}</>,
            value: item.dial_code + " " + item.name,
          }));

        setRequest({
          ...request,
          first_name: getValue(resp, `data.first_name`, ""),
          last_name: getValue(resp, `data.last_name`, ""),
          email: getValue(resp, `data.email`, ""),
          mobile_number: getValue(resp, `data.mobile_number`, ""),
          mobile_area_code:
            getValue(code, `length`, 0) > 0 ? getValue(code, `[${0}]`, "") : "",
          roles: getValue(resp, `data.roles`, []).map((item: object) => ({
            id: getValue(item, `id`, ""),
            // is_active: getValue(item, `is_active`, ""),
            title: getValue(item, `title`, ""),
            value: getValue(item, `title`, ""),
            label: getValue(item, `title`, ""),
          })),
          user_timezone: getValue(resp, `data.user_timezone`, ""),
          is_super_user: false,
          user_type: "CLIENT",
          is_invite: getValue(resp, `data.is_invite`, ""),
          is_mfa: getValue(resp, `data.is_mfa`, false),
        });
        setDirtyFields({
          ...dirtyFields,
          first_name: getValue(resp, `data.first_name`, ""),
          last_name: getValue(resp, `data.last_name`, ""),
          email: getValue(resp, `data.email`, ""),
          mobile_number: getValue(resp, `data.mobile_number`, ""),
          mobile_area_code:
            getValue(code, `length`, 0) > 0 ? getValue(code, `[${0}]`, "") : "",
          roles: getValue(resp, `data.roles`, []).map((item: object) => ({
            id: getValue(item, `id`, ""),
            // is_active: getValue(item, `is_active`, ""),
            title: getValue(item, `title`, ""),
            value: getValue(item, `title`, ""),
            label: getValue(item, `title`, ""),
          })),
          user_timezone: getValue(resp, `data.user_timezone`, ""),
          is_invite: getValue(resp, `data.is_invite`, ""),
          is_mfa: getValue(resp, `data.is_mfa`, false),

          is_super_user: false,
          user_type: "CLIENT",
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getRolesList = async () => {
    try {
      let payload: any = {
        page_size: params.limit ? parseInt(params.limit) : "100",
      };
      let queryRequest = QueryRequestHelper(payload);

      let resp = await adminGetRoles(queryRequest);
      if (resp) {
        setRolesList(
          getValue(resp, `data.roles`, []).map((item: object) => {
            return {
              id: getValue(item, `id`, ""),
              value: getValue(item, `title`, ""),
              label: getValue(item, `title`, ""),
            };
          }),
        );
      }
    } catch (error) {}
  };

  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();

    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        setIsLoading(true);
        let payload = {
          first_name: request.first_name,
          last_name: request.last_name,
          email: btoa(request.email.toLowerCase()),
          mobile_area_code: getValue(
            request,
            `mobile_area_code.value`,
            "",
          ).split(" ")[0],
          mobile_number: btoa(request.mobile_number),
          // roles: getValue(request,`roles`,[]).map((item:object)=>getValue(item,`id`,'')),
          roles: getValue(request, `roles`, []),
          user_timezone: request.user_timezone,
          is_super_user: request.is_super_user,
          user_type: request.user_type,
          is_invite: request.is_invite,
          is_mfa: request.is_mfa,
          //   send_invite: request.send_invite,
        };
        if (getValue(params, `id`, "")) {
          let resp = await adminUpdateSpecificUser(
            getValue(params, `id`, ""),
            payload,
          );
          if (resp) {
            setIsLoading(false);
            confirmNavigation();
            toast.success("Updated successfully");
            navigate(`/admin/users`);
          } else {
            setIsLoading(false);
          }
        } else {
          let resp = await adminCreateUser(payload, "");
          if (resp) {
            setIsLoading(false);
            reset();
            confirmNavigation();
            toast.success("Created successfully");
            navigate(`/admin/users`);
          } else {
            setIsLoading(false);
          }
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: sanitizeInput(value),
    });
  };

  const handleTimeZone = (value: any) => {
    setValue(request, "user_timezone", value);
    setRequest({ ...request });
  };

  const handleChangeCountryCode = (e: any) => {
    setValue(request, "mobile_area_code", e);
    setRequest({ ...request });
  };

  const handleChangeRole = (e: any) => {
    setValue(request, "roles", e);
    setRequest({ ...request });
  };

  /* -------------------------------------------------------------------------- */
  /*                                Prompt Section                              */
  /* -------------------------------------------------------------------------- */
  const [isChanged, setIsChanged] = useState(false);
  useEffect(() => {
    setIsChanged(
      _.isEqualWith(request, dirtyFields, (a: any, b: any) => {
        // if both are null or equal to an empty string then they are equal
        if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
      }),
    );
  });
  const [showPrompt, confirmNavigation, cancelNavigation]: any =
    useCallbackPrompt(!isChanged);

  return (
    <>
      {/* <Header /> */}
      <Layout>
        {!loading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "admin_general_user",
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <div className="user-add-edit-main-details-wrap">
              <PromptModal
                showDialog={showPrompt}
                confirmNavigation={confirmNavigation}
                cancelNavigation={cancelNavigation}
              />
              <AdminNavigation
                id={orgParams.id}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                url={`/admin/users`}
                isChanged={isChanged}
                permissions={props.permissions}
              />
              {
                // loading?
                // <p className="text-center mt-2">Please wait...</p>:
                <div className="user-details-wrapper ">
                  {/* <div className="user-details-wrapper__header d-flex align-items-center justify-content-between">
						<NavLink
							to="/admin/users"
							className="user-details-wrapper__header-back-link"
						>
							<img src="/images/back-link.svg" className="img-fluid" />
						</NavLink>
						<a href="#0" className="user-details-wrapper__add-user-info">
							User Details
						</a>
						<div className="user-details-wrapper__cta-btns">
							<NavLink to={`/admin/users`}>
								<button className="ascent-button ascent-button--header-buttons ascent-button--primary">
									Cancel
								</button>
							</NavLink>
							{isLoading ? (
								<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
									Please wait...
								</button>
							) : (
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--secondary"
									onClick={handleSubmit}
								>
									Send Invite
								</button>
							)}
						</div>
					</div> */}
                  {loading || !props.permissionAPITriggered ? (
                    <Loader />
                  ) : (
                    <div className="user-details-wrapper__form-wrapper">
                      <div className="user-details-wrapper__form">
                        <div className="user-details-wrapper__form-group form-group">
                          <label>
                            First Name <span>*</span>
                          </label>
                          <InputField
                            inputType="TEXT"
                            placeholder="Enter First Name"
                            className="form-control w-100"
                            name="first_name"
                            id="first_name"
                            value={getValue(request, `first_name`, "")}
                            onChange={(e: any) => handleChangeText(e)}
                            label="First Name"
                            validator={simpleValidator}
                          />
                        </div>
                        <div className="user-details-wrapper__form-group form-group">
                          <label>
                            Last Name <span>*</span>
                          </label>
                          <InputField
                            inputType="TEXT"
                            placeholder="Enter Last Name"
                            className="form-control w-100"
                            name="last_name"
                            id="last_name"
                            label="Last Name"
                            value={getValue(request, `last_name`, "")}
                            onChange={(e: any) => handleChangeText(e)}
                            validator={simpleValidator}
                          />
                        </div>
                        <div className="user-details-wrapper__form-group form-group">
                          <label>
                            Mobile Area Code <span>*</span>
                          </label>
                          <InputField
                            inputType="INPUT_REACT_SELECT_COUNTYCODE"
                            placeholder="Enter Mobile Area Code"
                            className="form-control w-100"
                            name="mobile_area_code"
                            id="mobile_area_code"
                            label="Mobile Area Code"
                            value={getValue(request, `mobile_area_code`, "")}
                            onChange={(e: any) => handleChangeCountryCode(e)}
                            validator={simpleValidator}
                          />
                        </div>
                        <div className="user-details-wrapper__form-group form-group">
                          <label>
                            Mobile Number <span>*</span>
                          </label>
                          <InputField
                            inputType="PHONE"
                            placeholder="Enter Mobile Number"
                            className="form-control w-100"
                            name="mobile_number"
                            id="mobile_number"
                            label="Mobile Number"
                            value={getValue(request, `mobile_number`, "")}
                            onChange={(e: any) => handleChangeText(e)}
                            validator={simpleValidator}
                          />
                        </div>
                        <div className="user-details-wrapper__form-group form-group">
                          <label>
                            Email ID <span>*</span>
                          </label>
                          <InputField
                            inputType="EMAIL"
                            placeholder="Enter Email ID"
                            className="form-control w-100"
                            name="email"
                            id="email"
                            label="Email"
                            value={getValue(request, `email`, "")}
                            onChange={(e: any) => handleChangeText(e)}
                            validator={simpleValidator}
                          />
                        </div>
                        <div className="user-details-wrapper__form-group form-group">
                          <label>
                            Time Zone <span>*</span>
                          </label>
                          <InputField
                            inputType="TIME_ZONE"
                            label="Time zone"
                            value={getValue(request, `user_timezone`, "")}
                            onChange={(timezone: any) => {
                              handleTimeZone(timezone);
                            }}
                            inputProps={{
                              placeholder: "Select Timezone...",
                              name: "timezone",
                            }}
                            validator={simpleValidator}
                            className="custom-select-time"
                          />
                        </div>
                      </div>
                      <div className="grid-multi">
                        <div className="input-grid-item">
                          <div>
                            <label
                              htmlFor="State"
                              className="filter-form-wrappper__label"
                            >
                              Role <span>*</span>
                            </label>
                            <div className="filter-form-wrappper__location-input form-group">
                              <InputField
                                inputType="INPUT_REACT_SELECT_MODAL"
                                placeholder="Choose Role"
                                name="roles"
                                id="roles"
                                value={getValue(request, `roles`, "")}
                                options={rolesList}
                                onChange={(value: any) => {
                                  handleChangeRole(value);
                                }}
                                label="Roles"
                                isMulti={true}
                                validator={simpleValidator}
                              />
                            </div>
                          </div>
                          <div className="">
                            <p className="">Send Invite</p>
                            <div className="choicelist-wrapper custom-switch-wrapper height-40 d-flex align-items-center">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={getValue(
                                    request,
                                    `is_invite`,
                                    false,
                                  )}
                                  onChange={() =>
                                    setRequest({
                                      ...request,
                                      is_invite: !getValue(
                                        request,
                                        `is_invite`,
                                        false,
                                      ),
                                    })
                                  }
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>

                          <div className="">
                            <p className="">MFA </p>
                            <div className="choicelist-wrapper custom-switch-wrapper ms-2  height-40 d-flex align-items-center">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={getValue(request, `is_mfa`, false)}
                                  onChange={() =>
                                    setRequest({
                                      ...request,
                                      is_mfa: !getValue(
                                        request,
                                        `is_mfa`,
                                        false,
                                      ),
                                    })
                                  }
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="user-details-wrapper__form-roles form-group my-2">
											<label>Roles</label>
											<InputField
												inputType="INPUT_REACT_SELECT"
												value={getValue(request, `roles`, "")}
												options={rolesList}
												onChange={(value: any) => {
													handleChangeRole(value);
												}}
												label="Roles"
												isMulti={true}
												validator={simpleValidator}
											/>
										</div> */}
                      {/* <div className="user-details-wrapper__form-batch-wrapper d-flex">
						<button className="badge d-flex align-items-center">
							Supervisor{" "}
							<img src="images/close-red.svg" className="img-fluid close-btn" />
						</button>
						<button className="badge d-flex align-items-center">
							Manager{" "}
							<img src="images/close-red.svg" className="img-fluid close-btn" />
						</button>
					</div> */}
                    </div>
                  )}
                </div>
              }
            </div>
          </>
        )}
      </Layout>
      {/* <div className="map-vendor__footer w-100">
				<img src="/images/footer-image.svg" className="img-fluid" />
			</div> */}
    </>
  );
};

export default UserDetailsInfo;
